import { render, staticRenderFns } from "./index.vue?vue&type=template&id=00a1b11b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=00a1b11b&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=00a1b11b&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a1b11b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00a1b11b')) {
      api.createRecord('00a1b11b', component.options)
    } else {
      api.reload('00a1b11b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=00a1b11b&scoped=true", function () {
      api.rerender('00a1b11b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/services/archiveds/index.vue"
export default component.exports